"use client";

import { WalletServiceProvider } from "@/app/context";
import { APIUserData } from "@/app/types/user";
import GlobalDataProvider from "@/app/utils/store/Context/globalContext";
import { ReactNode } from "react";

type Props = {
  user: APIUserData | null;
  children: ReactNode;
};

export default function ClientLayout({ children, user }: Readonly<Props>) {
  return (
    <GlobalDataProvider>
      <WalletServiceProvider user={user}>{children}</WalletServiceProvider>
    </GlobalDataProvider>
  );
}
